import { TOPIC_SEPARATOR } from '@cp/src/constants/Global';
import { NotificationTypes } from './constants';
import { NotificationsData, NotificationsTemplate, TemplatesMap } from './interfaces';
import { dateFormat } from 'src/utils/DateHelper';

export const calculateUnreadNotification = (notifications: NotificationsData[]) => {
  if (notifications) {
    const todaysDate = new Date();
    todaysDate.setDate(todaysDate.getDate() - 1);
    const yesterdaysDate = todaysDate.getTime();
    const unreadNotifications = notifications?.reduce(
      (unreadNoti: NotificationsData[], notification: NotificationsData) => {
        if (notification.createdAt > yesterdaysDate && hasNotCompletedAction(notification)) {
          unreadNoti.push(notification);
        }
        return unreadNoti;
      },
      []
    );
    return unreadNotifications.sort(
      (notificationA: NotificationsData, NotificationB: NotificationsData) =>
        notificationA.createdAt > NotificationB.createdAt ? -1 : 1
    );
  }
  return [];
};

export const templatesMap = (templates: NotificationsTemplate[]) => {
  const templatesMap: TemplatesMap = {};
  templates?.forEach(template => {
    templatesMap[template.id] = template;
  });
  return templatesMap;
};

export const hasNotCompletedAction = (notification: NotificationsData) => {
  if (!notification.actions) {
    return true;
  }
  return !Object.keys(notification.actions)?.length;
};

export const getTimeDifference = (createdAt: number): string => {
  const currentTime = new Date();
  const creationTime = new Date(createdAt);
  // this is timespamp difference
  const diff = Math.floor((currentTime.getTime() - creationTime.getTime()) / 60000);
  if (diff < 60) {
    return `${diff} ${diff <= 1 ? 'min' : 'mins'} ago`;
  }
  const hours = Math.floor(diff / 60);
  if (hours < 24) {
    return `${hours} ${hours <= 1 ? 'hr' : 'hrs'} ago`;
  }

  return dateFormat(creationTime, `dd MMM at HH:mm ${creationTime.getHours() >= 12 ? 'pm' : 'am'}`);
};

export const getNotificationWithoutPopUps = (notifications: NotificationsData[]) => {
  if (!notifications.length) return [];
  return notifications.filter(
    (notification: NotificationsData) =>
      notification?.flowType !== NotificationTypes.LONGHORN_POPUP &&
      notification?.flowType !== NotificationTypes.LONGHORN_STICKY_BANNER &&
      notification?.flowType !== NotificationTypes.TRIGGER_ONLY_FCM &&
      notification?.body?.notificationText !== 'AMEYO_CAMPAIGN_DOWN' &&
      notification?.body?.notificationText !== 'AMEYO_CAMPAIGN_UP' &&
      notification?.body?.notificationText !== 'AMEYO_LOW_CALLS' &&
      notification?.body?.notificationText !== 'AMEYO_NORMAL_CALLS'
  );
};

export const buildNotificationTopic = (
  businessVertical: string,
  caseReferenceId: string,
  alertType: string
): string => {
  return [businessVertical, caseReferenceId, alertType].join(TOPIC_SEPARATOR);
};
